let forceEmail = false;

export const setForceEmail = (value: boolean) => {
  forceEmail = value;
};

export const getForceEmail = () => forceEmail;
